module.exports = __webpack_public_path__ + "img/maintenanceScreen-gif.5797e634.gif";